/**
 * @generated SignedSource<<89f71dcc06a25a5687902fc40d3a24bf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type NoteStreamType = "goalset" | "meeting" | "oneonone" | "personal";
import { FragmentRefs } from "relay-runtime";
export type SendNotesModal_note$data = {
  readonly eventEnd: string | null;
  readonly eventStart: string | null;
  readonly finished: boolean;
  readonly id: string;
  readonly meetingRecordings: ReadonlyArray<{
    readonly id: string;
  }> | null;
  readonly noteTitle: string;
  readonly noteType: NoteStreamType;
  readonly stream: {
    readonly id: string;
    readonly isExternal: boolean;
  };
  readonly version: number;
  readonly " $fragmentSpreads": FragmentRefs<"SendNotesModal_IncludeAISummaryFormField_note" | "SendNotesModal_Timing_note">;
  readonly " $fragmentType": "SendNotesModal_note";
};
export type SendNotesModal_note$key = {
  readonly " $data"?: SendNotesModal_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"SendNotesModal_note">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SendNotesModal_note",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventStart",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventEnd",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "finished",
      "storageKey": null
    },
    {
      "alias": "noteTitle",
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "noteType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MeetingRecording",
      "kind": "LinkedField",
      "name": "meetingRecordings",
      "plural": true,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteStream",
      "kind": "LinkedField",
      "name": "stream",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isExternal",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SendNotesModal_IncludeAISummaryFormField_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SendNotesModal_Timing_note"
    }
  ],
  "type": "Note",
  "abstractKey": null
};
})();

(node as any).hash = "9cf6f6d84407f431e572719eaa6755ee";

export default node;
